import { type Theme } from "@mui/material";
import { SPFAvailabilityStatus } from "@src/utils/events";
import { type IntlShape } from "react-intl";

export const resolveAvailabilityStatus = (status: SPFAvailabilityStatus, intl: IntlShape) => {
    switch (status) {
        case SPFAvailabilityStatus.Available:
            return intl.formatMessage({ id: "sparePartsFinder.subgroupPage.availabilityStatusMessage.available", defaultMessage: "Available" });
        case SPFAvailabilityStatus.NotAvailable:
            return intl.formatMessage({
                id: "sparePartsFinder.subgroupPage.availabilityStatusMessage.notAvailable",
                defaultMessage: "Not available",
            });
        case SPFAvailabilityStatus.ManufacturerAvailable:
            return intl.formatMessage({
                id: "sparePartsFinder.subgroupPage.availabilityStatusMessage.manufacturerAvailable",
                defaultMessage: "Available at manufacturer",
            });
        case SPFAvailabilityStatus.Unknown:
        default:
            return intl.formatMessage({ id: "sparePartsFinder.subgroupPage.availabilityStatusMessage.unknown", defaultMessage: "Unknown" });
    }
};

export const resolveAvailabilityStatusColor = (availabilityStatus: string, theme: Theme): string => {
    if (availabilityStatus === SPFAvailabilityStatus.Available) return theme.palette.green._50;
    if (availabilityStatus === SPFAvailabilityStatus.NotAvailable) return theme.palette.red._50;
    if (availabilityStatus === SPFAvailabilityStatus.ManufacturerAvailable) return theme.palette.yellow._50;

    return theme.palette.core.grey._30;
};
